module.exports = __webpack_public_path__ + "static/mary-kay-5-c7a706dcf7bbf6d79ccd62160390b3a4.jpg";